import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import Footer from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <Features data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}